// extracted by mini-css-extract-plugin
export default {"text":"EvaluateRadio_text__YzLf7"};